import React from 'react';

import styles from '../styles/HomeBannerText.module.scss';

interface HomeBannerTextCmpProps {
  title: string;
  description: string;
}

function HomeBannerTextCmp({
  title,
  description,
}: HomeBannerTextCmpProps): React.ReactElement {
  return (
    <div className={styles['banner-wrapper']}>
      <h1 className={styles['banner-subtext']}>{description}</h1>
      <h1 className={styles['banner-text']}>{title}</h1>
    </div>
  );
}

export default HomeBannerTextCmp;
